import { CAN_USE_DOM } from "common/lib/utils"
import type { Referrer } from "@theconversation/shared-libraries/tcEventsCollector/tcEvent"

/**
 * Return referrer details from document.referrer
 * Returns undefined when DOM/referrer is unavailable or invalid
 */
export function getReferrer(): Referrer | undefined {
  if (!CAN_USE_DOM) return undefined

  try {
    const referrerValue = document.referrer?.trim()
    if (!referrerValue) return undefined

    const referrerUrl = new URL(referrerValue)
    const domain = referrerUrl.hostname?.trim()
    if (!domain) return undefined
    const path = referrerUrl.pathname?.trim()

    return {
      domain,
      ...(path && { path }),
    }
  } catch {
    return undefined
  }
}
